/*global
    jQuery, aap, Awesomplete
*/
(function ($) {

    'use strict';
    var $petcoLegalModal = $('div.petco-legal-disclaimer');
    var recordLegalAccept = function() {
        var $form = $('form#record-legal-accept');
        if ( $form.length > 0 ) {
            var $relinquisher_id = $('input[name="relinquisher_id"]');
            if ( $relinquisher_id.length === 0 ) {
                $.ajax({
                    url: '/petco/adopter-accepted-legal',
                    method: 'POST',
                    data: $form.serialize(),
                    success: function (data, status) {
                        if (data.status != undefined && data.status == 'success') {
                            $petcoLegalModal.addClass('closed');
                        }
                        enableSeeStoresButton();
                    }
                });
            } else { 
                $.ajax({
                    url: '/mypets/petco/relinquisher-accepted-legal',
                    method: 'POST',
                    data: $form.serialize(),
                    success: function (data, status) {
                        if (data.status != undefined && data.status == 'success') {
                            $petcoLegalModal.addClass('closed');
                        }
                        enableSeeStoresButton();
                    }
                });
            }
        }
    }

    var disableSeeStoresButton = function() {
        var $seeStoresButton = $('a#see-store-list');
        if ( $seeStoresButton.length > 0 ) {
            $seeStoresButton.on('click', function(e) {
                e.preventDefault();
                alert('You must agree to Adopt-a-Pet.com and its Parties Terms and Conditions before viewing a list of participating stores.');
                return false;
            });
        }
    }

    var enableSeeStoresButton = function() {
        var $seeStoresButton = $('a#see-store-list');
        if ( $seeStoresButton.length > 0 ) {
            $seeStoresButton.off('click');
        }
    }

    if ( $petcoLegalModal.length > 0 ) {
        disableSeeStoresButton();
        var $acceptLegal = $('button#petco-agree');
        if ( $acceptLegal.length > 0 ) {
            $acceptLegal.on('click', function() {
                recordLegalAccept();
            });
        }
    }

    var $petcoAd = $('.petco-ad-banner');
    if ( $petcoAd.length > 0 ) {
        var $closeButton = $petcoAd.find("button#close");
        if ( $closeButton.length > 0 ) {
            $closeButton.on('click', function() {
                $petcoAd.remove();
                // Make ajax call to dismiss add permanently
                $.get('/hide-petco-ad', function(data, status) {
                });
            });
        }
    }

}(jQuery));
